// extracted by mini-css-extract-plugin
export default {"gold":"ItemLeaderboard_gold__OvoIk","silver":"ItemLeaderboard_silver__3AoFZ","bronze":"ItemLeaderboard_bronze__zwLnd","blue":"ItemLeaderboard_blue__xtwff"};